import { addIcons } from 'ionicons';
import { defineCustomElement as defineIonIcon } from 'ionicons/components/ion-icon.js';
import {
  carOutline,
  cartOutline,
  hammerOutline,
  happyOutline,
  flowerOutline,
  restaurantOutline,
  schoolOutline,
  ellipsisHorizontalOutline,
  pricetagOutline,
  giftOutline,
  swapHorizontalOutline,
  repeatOutline,
  searchOutline,
  megaphoneOutline,
  warningOutline,
  calendarOutline,
  trashOutline,
  businessOutline,
  peopleCircleOutline,
  storefrontOutline,
  personOutline,
  footballOutline,
  colorPaletteOutline,
  heartOutline,
  leafOutline,
  shieldCheckmarkOutline,
  peopleOutline,
  briefcaseOutline,
  medkitOutline,
  constructOutline,
  checkmarkCircleOutline,
  closeCircleOutline,
  informationCircleOutline,
  eyeOutline,
  homeOutline,
  chatbubbleEllipsesOutline,
} from 'ionicons/icons';

export const CATALOG_ICONS: Record<string, string> = {
  'car-outline': carOutline,
  'cart-outline': cartOutline,
  'hammer-outline': hammerOutline,
  'happy-outline': happyOutline,
  'flower-outline': flowerOutline,
  'restaurant-outline': restaurantOutline,
  'school-outline': schoolOutline,
  'ellipsis-horizontal-outline': ellipsisHorizontalOutline,
  'pricetag-outline': pricetagOutline,
  'gift-outline': giftOutline,
  'swap-horizontal-outline': swapHorizontalOutline,
  'repeat-outline': repeatOutline,
  'search-outline': searchOutline,
  'megaphone-outline': megaphoneOutline,
  'warning-outline': warningOutline,
  'calendar-outline': calendarOutline,
  'trash-outline': trashOutline,
  'business-outline': businessOutline,
  'people-circle-outline': peopleCircleOutline,
  'storefront-outline': storefrontOutline,
  'person-outline': personOutline,
  'football-outline': footballOutline,
  'color-palette-outline': colorPaletteOutline,
  'heart-outline': heartOutline,
  'leaf-outline': leafOutline,
  'shield-checkmark-outline': shieldCheckmarkOutline,
  'people-outline': peopleOutline,
  'briefcase-outline': briefcaseOutline,
  'medkit-outline': medkitOutline,
  'construct-outline': constructOutline,
  'checkmark-circle-outline': checkmarkCircleOutline,
  'close-circle-outline': closeCircleOutline,
  'information-circle-outline': informationCircleOutline,
  'eye-outline': eyeOutline,
  'home-outline': homeOutline,
  'chatbubble-ellipses-outline': chatbubbleEllipsesOutline,
};

export function registerCatalogIcons(): void {
  defineIonIcon();
  addIcons(CATALOG_ICONS);
}
